import { render, staticRenderFns } from "./StpfstFlats.vue?vue&type=template&id=b3257832&scoped=true"
import script from "./StpfstFlats.vue?vue&type=script&lang=js"
export * from "./StpfstFlats.vue?vue&type=script&lang=js"
import style0 from "./StpfstFlats.vue?vue&type=style&index=0&id=b3257832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3257832",
  null
  
)

export default component.exports